import { render, staticRenderFns } from "./ConfigurationMyPiggybank.vue?vue&type=template&id=66ff6c1c&scoped=true"
import script from "./ConfigurationMyPiggybank.vue?vue&type=script&lang=js"
export * from "./ConfigurationMyPiggybank.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationMyPiggybank.vue?vue&type=style&index=0&id=66ff6c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff6c1c",
  null
  
)

export default component.exports